const React = require('react');
const UserSearchFilterDialog = require('components/UserSearchFilterDialog');

const {
    useMemo,
    useState
} = React;

const internals = {};

module.exports = function UserSearchFilterHarnessPage() {

    const query = internals.getQueryParams();
    const fixture = query.get('fixture') || 'default';
    const [state, setState] = useState({
        closeCount: 0,
        lastResetSortType: null,
        lastSubmit: null,
        open: true
    });

    const handlers = useMemo(() => ({
        onRequestClose: () => {

            setState((current) => ({
                ...current,
                closeCount: current.closeCount + 1,
                open: false
            }));
        },
        onSubmit: async (criteria, discoverSortType) => {

            setState((current) => ({
                ...current,
                lastSubmit: {
                    criteria,
                    discoverSortType
                }
            }));

            return true;
        },
        resetSearch: async (discoverSortType) => {

            setState((current) => ({
                ...current,
                lastResetSortType: discoverSortType
            }));

            return true;
        }
    }), []);

    const props = useMemo(() => internals.buildDialogProps({
        fixture,
        handlers,
        open: state.open
    }), [fixture, handlers, state.open]);

    return <div data-testid='user-search-filter-harness'>
        <div
            data-testid='user-search-filter-harness-state'
            style={{
                position: 'absolute',
                left: '-10000px',
                top: 0
            }}
        >
            <div>fixture: {fixture}</div>
            <div data-testid='user-search-filter-close-count'>close count: {state.closeCount}</div>
            <div data-testid='user-search-filter-last-reset-sort-type'>{state.lastResetSortType || 'null'}</div>
            <pre data-testid='user-search-filter-last-submit-json'>{JSON.stringify(state.lastSubmit, null, 2)}</pre>
        </div>
        <UserSearchFilterDialog {...props} />
    </div>;
};

internals.getQueryParams = () => new URLSearchParams(window.location.search);

internals.role = {
    id: 1,
    name: 'student',
    label: 'Student',
    permissions: {
        canEditBadge: true,
        canEditBio: true,
        canEditCareerAspiration: true,
        canEditGraduatingClass: true,
        canEditHomeTown: true,
        canEditIncomingClass: true,
        canEditMajor: true,
        canEditOnline: true,
        canEditOpenSocial: true,
        canEditParent: true,
        canEditProfession: true,
        canEditTimeStatus: true,
        canEditTitle: true,
        canEditTransfer: true,
        canEditVeteran: true
    }
};

internals.interests = [
    { id: 1, name: 'Art' },
    { id: 2, name: 'Biology' }
];

internals.buildSearchFilter = (fixture) => {

    if (fixture === 'custom-selected') {
        return {
            contextFilter: 'student',
            locationType: 'custom',
            radius: 10,
            customLocation: {
                id: null,
                placeId: 'seed-place',
                name: 'St. Louis, Missouri, USA'
            }
        };
    }

    return {
        contextFilter: 'student'
    };
};

internals.buildDialogProps = ({
    fixture,
    handlers,
    open
}) => ({
    activeSearchFilter: internals.buildSearchFilter(fixture),
    allRoles: [internals.role],
    badges: [],
    canSearchHometown: true,
    canSearchHousing: true,
    classId: 42,
    currentUserPermissions: {},
    currentUserRole: internals.role,
    departments: [],
    discoverSortType: 'BEST_MATCH',
    graduatingClassList: [
        { value: '2025', label: '2025' }
    ],
    incomingClassList: [
        { value: '2024', label: '2024' }
    ],
    interests: internals.interests,
    isBlankSearch: false,
    isCommunity: false,
    isCompany: false,
    isSchoolOnline: false,
    majors: [
        { id: 7, name: 'Computer Science' }
    ],
    officesList: [],
    onRequestClose: handlers.onRequestClose,
    onSubmit: handlers.onSubmit,
    open,
    resetSearch: handlers.resetSearch,
    schoolRoles: [internals.role],
    yearsHiredList: []
});

module.exports.internals = internals;
